/*
 * @Author       : yilei
 * @Date         : 2023-01-31 17:38:16
 * @LastEditTime : 2023-04-28 16:47:21
 * @LastEditors  : yilei
 */
import React, { useEffect, useState } from 'react'
import { registerMicroApps, start } from 'qiankun'
import clsx from 'clsx'
import { getSubAppConfig, excludeAssetWhiteList } from '@/index.config'
import { BrowserRouter } from 'react-router-dom'
import DefaultLayout from '@/components/layout/default'
import { USE_NEW_LAYOUT_COOKIE, GET_LAYOUT_GRAY_INFO, Y } from '@/constant'
import styles from './index.module.less'
import { Spin } from 'antd'
import '@/utils/soj'
import { getCookie } from '@/utils/common'
import { ajklogInit } from '@/utils/ajklog'
import AgreementModal from '@/components/agreementModal'
import { getNewLayoutGrayInfo } from '@/services/api'

const customFetch = function (...args: Parameters<typeof fetch>) {
  return window.fetch(...args)
    .catch(err => {
      // 防止页面刷新导致新开埋点tab页
      setTimeout(() => {
        // soj埋点
        window.loggerAction?.sendnpv?.({
          action: 'qiankun-load-source-failed',
          ep: { from: 'mendian-main', url: args[0], err: err?.stack?.replace(/'/g, '"') }
        })
        // 北斗埋点
        window.Beidou?.captureException(err, { tags: { action: 'qiankun-load-source-failed', url: args[0] } })
      }, 0)
      throw err
    })
}

const defaultLayoutValue = getCookie(USE_NEW_LAYOUT_COOKIE) === Y

const BasicRoute = (): JSX.Element => {
  const [loading, uploadLoading] = useState<boolean>(false)
  const [grayLoading, setGrayLoading] = useState(true)
  const [useNewLayout, setUseNewLayout] = useState(defaultLayoutValue)
  const [useOnlyNewLayout, setOnlyUseNewLayout] = useState(false)

  const init = async () => {
    try {
      const [useNewLayoutRes, useOnlyNewLayoutRes] = await Promise.all([
        GET_LAYOUT_GRAY_INFO(),
        getNewLayoutGrayInfo()
      ])

      const onlyNewLayout = useOnlyNewLayoutRes?.data?.forceNew || false

      setUseNewLayout(onlyNewLayout ? true : useNewLayoutRes === Y)
      window.loggerAction?.sendnpv?.({
        action: onlyNewLayout ? 'jikejia_new_layout' : useNewLayoutRes === Y ? 'jikejia_new_layout' : 'jikejia_old_layout'
      })

      setOnlyUseNewLayout(onlyNewLayout)
      setGrayLoading(false)
    } catch (error) {
      console.log(error)
      setUseNewLayout(false)
      setOnlyUseNewLayout(false)
      setGrayLoading(false)
    }
  }

  useEffect(() => {
    init()

    const loader = (loading: any) => {
      uploadLoading(loading)
    }
    const subappConfig: any[] = getSubAppConfig(loader)
    registerMicroApps(
      subappConfig,
      {
        beforeLoad: () => {
          ajklogInit()
          return Promise.resolve()
        }
      }
    )
    start({
      prefetch: false,
      excludeAssetFilter: (assetUrl: string): any => {
        // excludeAssetFilter 参数来放行这部分资源请求
        const whiteList: string[] = excludeAssetWhiteList
        console.log('assetUrl=', assetUrl)
        const res: string | undefined = whiteList.find((item) => assetUrl.includes(item))
        return !!res
      },
      // 自定义fetch捕获 ‘failed to fetch’ 资源错误
      fetch: customFetch,
      singular: false
    })
  }, [])

  return <>
    <BrowserRouter>
      <DefaultLayout grayLoading={grayLoading} useNewLayout={useNewLayout} useOnlyNewLayout={useOnlyNewLayout}>
        <Spin tip="页面加载中，请稍后..." spinning={loading || grayLoading} wrapperClassName={styles.mainLayout}>
          <div id="subapp-viewport" className={clsx(styles.subappContainer, { [styles.grayLoading]: grayLoading })}></div>
          <AgreementModal ></AgreementModal>
        </Spin>
      </DefaultLayout>
    </BrowserRouter>
  </>
}
export default BasicRoute
